// Configuración centralizada de la aplicación
//
// Detección de entorno por orden de prioridad:
//   1. Capacitor APK Android (window.Capacitor.isNativePlatform()) → Railway cloud
//   2. localhost / 127.0.0.1                                       → MySQL local
//   3. IP LAN privada (192.168.x.x, 10.x.x.x, 172.16-31.x.x)       → MySQL local
//   4. Cualquier otro hostname (mediexampro.com)                   → Railway cloud
//
// Service Token Cloudflare Access:
//   El APK Capacitor envía los headers CF-Access-Client-Id / CF-Access-Client-Secret
//   en cada fetch a api.mediexampro.com para pasar Cloudflare Access.
//   En navegador (mediexampro.com) la cookie de sesión CF Access basta.
const config = {
  api: {
    local: {
      baseUrl: 'http://localhost:3001/api',
      useLocalMySQL: true,
      description: 'MySQL local con Server.js'
    },
    production: {
      baseUrl: 'https://api.mediexampro.com/api',
      useRailway: true,
      description: 'Railway en la nube (Server.js + MySQL managed)'
    }
  },

  // Credenciales Service Token CF Access (inyectadas en build via REACT_APP_*)
  cfAccess: {
    clientId: process.env.REACT_APP_CF_ACCESS_CLIENT_ID || '',
    clientSecret: process.env.REACT_APP_CF_ACCESS_CLIENT_SECRET || ''
  },

  // Detecta si la app está corriendo dentro de un container Capacitor (APK Android).
  // En ese caso `window.Capacitor` existe y `isNativePlatform()` retorna true.
  isCapacitorNative: () => {
    if (typeof window === 'undefined') return false;
    return !!(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
  },

  getApiUrl: () => {
    if (typeof window === 'undefined') {
      return config.api.local.baseUrl;
    }

    // 1) Capacitor APK → SIEMPRE cloud (el APK no tiene "localhost local")
    if (config.isCapacitorNative()) {
      return config.api.production.baseUrl;
    }

    const host = window.location.hostname;
    const protocol = window.location.protocol;

    // 2) localhost o 127.0.0.1 → MySQL local
    if (host === 'localhost' || host === '127.0.0.1') {
      return config.api.local.baseUrl;
    }

    // 3) IP LAN privada → MySQL local (PC actuando como servidor para cel/tablet)
    const isLanIp =
      /^192\.168\.\d{1,3}\.\d{1,3}$/.test(host) ||
      /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host) ||
      /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host);

    if (isLanIp) {
      return `${protocol}//${host}:3001/api`;
    }

    // 4) Otro hostname (mediexampro.com, etc.) → cloud Railway
    return config.api.production.baseUrl;
  },

  // Devuelve los headers extra que debe llevar cada fetch.
  // Aplica en TODOS los entornos cloud (APK + browser en mediexampro.com)
  // porque la cookie de CF Access NO cruza subdominios (mediexampro.com vs
  // api.mediexampro.com son hosts distintos para el browser). El Service
  // Token es la única forma de auth que funciona cross-subdomain.
  //
  // Trade-off: el secret queda visible en el bundle JS del frontend, pero
  // ese bundle solo es accesible para quien pase CF Access en mediexampro.com
  // (usuario único Alexis). Riesgo real = bajo.
  getAuthHeaders: () => {
    if (!config.cfAccess.clientId || !config.cfAccess.clientSecret) return {};
    return {
      'CF-Access-Client-Id': config.cfAccess.clientId,
      'CF-Access-Client-Secret': config.cfAccess.clientSecret
    };
  },

  // Para endpoints específicos
  endpoints: {
    questions: () => `${config.getApiUrl()}/questions`,
    questionsFilter: () => `${config.getApiUrl()}/questions/filter`,
    questionsCount: () => `${config.getApiUrl()}/questions/count`,
    test: () => `${config.getApiUrl()}/test`
  }
};

// ─────────────────────────────────────────────────────────────────────────
// Patch global de fetch — inyecta headers CF Access en cada request al API
// de producción cuando la app corre dentro del APK Capacitor.
//
// Sin esto tendríamos que tocar cada componente que llama a fetch.
// Con este patch, todo el código existente sigue funcionando sin cambios.
// ─────────────────────────────────────────────────────────────────────────
if (typeof window !== 'undefined' && !window.__cfAccessFetchPatched) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = function patchedFetch(input, init = {}) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      // Inyectar headers Service Token en cualquier fetch a api.mediexampro.com
      // (APK Capacitor + browser desde mediexampro.com). La cookie de CF Access
      // no cruza subdominios → Service Token es la única auth válida cross-host.
      const targetsCloud = url.includes('api.mediexampro.com');
      if (targetsCloud) {
        const cfHeaders = config.getAuthHeaders();
        if (cfHeaders['CF-Access-Client-Id']) {
          const mergedHeaders = new Headers(init.headers || {});
          mergedHeaders.set('CF-Access-Client-Id', cfHeaders['CF-Access-Client-Id']);
          mergedHeaders.set('CF-Access-Client-Secret', cfHeaders['CF-Access-Client-Secret']);
          init = { ...init, headers: mergedHeaders };
        }
      }
    } catch (_) {
      // si algo falla en el patch, dejamos pasar el fetch original sin headers
    }
    return originalFetch(input, init);
  };
  window.__cfAccessFetchPatched = true;
}

export default config;